/**
 * Cores das telas por função (modo escuro e modo claro). É a fonte única do padrão visual: o tema do MUI
 * (assets/theme e assets/theme-dark) e as telas usam estas cores, nunca um código hexadecimal solto.
 *
 * Modo escuro no estilo do Outlook: cinzas neutros médios (sem o tom azulado de antes), com o fundo sempre um tom
 * mais escuro que os blocos da frente, sem ficar cansativo. Para clarear ou escurecer o sistema inteiro, ajuste só aqui.
 *
 * Uso nas telas:
 *   import { ESCURO, coresDoTema } from "assets/coresTema";
 *   sx={{ backgroundColor: darkMode ? ESCURO.cartao : CLARO.cartao }}
 *   const cores = coresDoTema(darkMode);  sx={{ border: `1px solid ${cores.borda}` }}
 */

export const ESCURO = {
    fundo: "#626262", //         área de trabalho (atrás dos blocos)
    barra: "#585858", //         barra das abas e cabeçalhos fixos
    cartao: "#747474", //        blocos/cards das telas
    painel: "#6e6e6e", //        faixa ou área destacada dentro de um bloco (filtros, cabeçalho de tabela, banners)
    painelEscuro: "#686868", //  área mais funda dentro de um bloco (rodapé, listas, abas internas)
    campo: "#7c7c7c", //         fundo dos campos (input, select, autocomplete)
    hover: "#808080", //         linha/item com o mouse em cima, item selecionado
    linhaAlternada: "#797979", // linha zebrada de tabela
    borda: "#989898", //         borda de campos e blocos
    divisoria: "#868686", //     linhas divisórias (tabela, separadores)
    bordaForte: "#a8a8a8", //    borda de destaque (foco sem cor, contorno de cartão selecionado)
    texto: "#ffffff", //         texto principal
    textoSecundario: "#f5f5f5", // rótulos e textos de apoio
    grafico: "#4a4a4a", //      área dos gráficos: mais funda que o bloco, para as barras e linhas se destacarem
    textoFraco: "#e0e0e0", //    legendas, placeholders, desabilitados
};

export const CLARO = {
    fundo: "#f0f2f5",
    barra: "#ffffff",
    cartao: "#ffffff",
    painel: "#fafafa",
    painelEscuro: "#f0f2f5",
    campo: "#ffffff",
    hover: "#f5f5f5",
    linhaAlternada: "#fafafa",
    borda: "#d2d6da",
    divisoria: "#e9ecef",
    bordaForte: "#adb5bd",
    texto: "#344767",
    textoSecundario: "#495057",
    textoFraco: "#7b809a",
    grafico: "#fafafa",
};

export const coresDoTema = (darkMode) => (darkMode ? ESCURO : CLARO);

/**
 * Texto colorido no modo escuro (MDTypography color="error" etc.): tons mais claros que as cores do tema, para ler bem
 * sobre o cinza médio dos blocos (contraste >= 3:1 sobre ESCURO.cartao). Ex.: fichas devolvidas em vermelho.
 */
export const TEXTO_COLORIDO_ESCURO = {
    error: "#ffc6c6",
    success: "#c6eac6",
    warning: "#ffdfaa",
    info: "#c2deef",
    primary: "#f5d7a6",
};

/** Tamanhos padrão de texto das telas (rem), iguais nos dois modos. */
export const FONTE = {
    rotulo: "0.75rem", //     rótulo acima do campo (InputLabel)
    campo: "0.75rem", //      texto digitado nos campos (igual ao MDInput)
    tabela: "0.8125rem", //   células de tabela
    cabecalho: "0.7rem", //   cabeçalho de tabela
    legenda: "0.7rem", //     textos de ajuda (caption)
};
